(function($) {


	var wow = new WOW(
      {
  		mobile: false
    }
    )
    wow.init();

	//universal vars
	var 	siteHeader = $('header.site-header'),
			backgroundwrapper = $('.background-wrapper'),
			scrollDistance = $(window).scrollTop();

	$(document).ready(function(){

		$('.testimonials-slider').slick({
		  dots: true,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 1,
		  arrows: false,
		  //fade: true,
		  //centerMode: false,
		  //centerPadding: '100px',
		  appendDots:  $('#test-home-dots'),
		  responsive: [
			
			{
			  breakpoint: 480,
			  settings: {
			    adaptiveHeight: true,
			    autoplay: false,
			  }
			}
			]
		});

		$('.homepage-slider').slick({
		  dots: false,
		  infinite: true,
		  speed: 1000,
		  slidesToShow: 1,
		  arrows: false,
		  adaptiveHeight: false,
		  autoplay: true,
		  fade: true,
		  //appendArrows: $('.homepage-slide-arrows'),
		  //appendDots:  $('.homepage-slide-dots'),
		  responsive: [
			{
			  breakpoint: 768,
			  settings: {
			    dots: true,
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			  }
			}
			]
		});

		
		$('.awards-slider').slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 400,
			slidesToShow: 5,
			centerMode: false,
			autoplay: true,
			responsive: [
			{
			  breakpoint: 768,
			  settings: {
			    slidesToShow: 5
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			    slidesToShow: 2,
			     centerMode: false,
			  }
			}
			]
		});

		$('.treatments-slider').slick({
			dots: false,
			arrows: true,
			infinite: true,
			speed: 400,
			slidesToShow: 2,
			centerMode: false,
			autoplay: true,
			appendArrows: $('#treatment-arrows'),
		  	//appendDots:  $('.homepage-slide-dots'),
			responsive: [
			{
			  breakpoint: 769,
			  settings: {
			    slidesToShow: 1,
			    centerMode: true,
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			    slidesToShow: 1,
			    centerMode: true,
			    centerPadding: '20px',
			  }
			}
			]
		});



	//This option is for pages with a slider of images
	var lightbox = new SimpleLightbox('.image-gallery>.single-image>a', { /* options */ });
	var lightboxGrid = new SimpleLightbox('.image-gallery-grid>.single-image>a', { /* options */ });

		$('.image-gallery').slick({
		  arrows: true,
		  infinite: true,
		  dots: false,
		  speed: 300,
		  slidesToShow: 1,
		  centerMode: true,
		  variableWidth: true,
		  autoplay:true,
		  initialSlide: 1,
		  //asNavFor: '.image-gallery-header-slider',
		  // appendArrows: $('.gallery-slide-arrows'),
		  // appendDots:  $('.gallery-slide-dots'),
		});

		$('.image-gallery-header-slider').slick({
		  arrows: false,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 1,
		  autoplay:true,
		  initialSlide: 1,
		  //asNavFor: '.image-gallery',
		  fade: true,
		});




		//This will create a lightbox gallery to replace the default wordpress gallery
		 var galleryItems = $('figure.wp-block-gallery figure.wp-block-image');

		  galleryItems.each(function() {
		  
		  var   caption = $(this).find( "figcaption" ),
		        captionText = $(caption).text(),
		        link = $(this).find( "a" ),
		        image = $(this).find( "img" );
		  $(image).attr('title', captionText);


		  });
		   // Galleries on Project Pages

		   if($('figure.wp-block-gallery').length > 0) {
		      var lightbox = new SimpleLightbox('figure.wp-block-gallery figure.wp-block-image a', {
		        // captionSelector : 'figcaption',
		        // captionType : 'text'
		      });
		    }

		//hide events on homepage if empty 

		if($('.eventer-no-event-found').length > 0) {
			$('#homepage-events').hide();
		}
	});

	$(window).on('load',function() {

		// Animate loader off screen
	    $("#loader").fadeOut(300);
	});

	
	//scroll functions

	$(window).on('scroll',function() {
		scrollDistance = $(window).scrollTop();
		stickyHeaderClass(scrollDistance,50,siteHeader);
		if(scrollDistance > 100) {
			$('.booking-call-overlay').addClass('scrolled-call');
		}
		else {
			$('.booking-call-overlay').removeClass('scrolled-call');
		}
	});

	//sticky header function
	var stickyHeaderClass = function(scrollDistanceMonitor, classDistance, headerSelector){
		if(scrollDistanceMonitor > classDistance) {
			$(headerSelector).addClass('scrolled');
			// $('.top-title img').fadeOut('slow', function(){
			// 	$('.scroll-title img').fadeIn('slow', function() {
			// 		$('.site-title img').addClass('scaled-title');

			// 	});
			// });	
		}
		else {
			$(headerSelector).removeClass('scrolled');
			// $('.scroll-title img').fadeOut('slow', function(){
			// 	$('.top-title img').fadeIn('slow', function() {
			// 		$('.site-title img').removeClass('scaled-title');
			// 	});
			// });
		}
	};


//animate all anchor links

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth',
            block: "nearest", 
        });
    });
});


$('button.hamburger').on('click',function(event){
	$(this).toggleClass('is-active');
});

//open and close search menu
$('.mini-cart-toggle').on("click", function (event) {
    event.preventDefault();
    $('.mini-cart').toggleClass('opened');
    $('body').toggleClass('cart-opened');
    event.stopPropagation();
});

$(document).on('click' , function(e){
    var $menu = $('.nav-primary'),
        $targetBody = $('body'),
        $menuButton = $('.menu-toggle'),
        $miniCart = $('.mini-cart')
        // $searchOverlay = $(".search-overlay"),
        // $menuSearchButton = $('.menu-search a');

    // When the search menu is open this will close it on click outside form
    if (!$miniCart.is(e.target) // if the target of the click isn't the container...
    && $miniCart.has(e.target).length === 0 && !$miniCart.is(e.target) && $targetBody.hasClass('cart-opened')) 
    // ... nor a descendant of the container

    {       event.preventDefault();
            $($targetBody).removeClass('cart-opened');
            $('.mini-cart').toggleClass('opened');
            event.stopPropagation();
    }
});

jQuery(document).ready(function($){
    $('body').on( 'added_to_cart', function(){
        event.preventDefault();
	    $('.mini-cart').toggleClass('opened');
	    $('body').toggleClass('cart-opened');
	    event.stopPropagation();
    });

});

// treatment diagram 

$('#clickable>g, #clickable-side>g').on('mouseup',function(event){
	var muscleTitle = $(this).data('area-title'),
		muscleContent = $(this).data('area-content'),
		importantInfo = $('.important-info').html();

		if(importantInfo) {
			modalContent = '<h3>' + muscleTitle + '</h3>' + importantInfo + '<p>' + muscleContent + '</p>';
		}
		else {
			modalContent = '<h3>' + muscleTitle + '</h3>' + '<p>' + muscleContent + '</p>';
		}
	if(muscleTitle) {
		$(this).featherlight(modalContent);
	}
	else {
		$(this).featherlight('<h3>Treatment Area</h3>' + '<p>This area will be included as part of this treatment.</p>');
	}
});

var bgVid = $("#bgvid"),
	deskSrcmp4 = $('#deskSrcmp4').val();
	bgVid.append("<source type='video/mp4' src='" + deskSrcmp4 + "' />");
	bgVid.prop('muted',true);
	
})( jQuery );